import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SessionType } from '@models/Sessions/Config';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'topic-type-switcher',
  templateUrl: './topic-type-switcher.component.html',
  styleUrls: ['./topic-type-switcher.component.scss'],
})
export class TopicTypeSwitcherComponent {
  @Input() type: SessionType;
  @Output() typeChange = new EventEmitter<SessionType>();
}
